import CommonIFrame from '../atoms/CommonIFrame';

const ScenarioVsGoal = () => {
    return (
        <CommonIFrame
            src="https://pl7ftyftutu.lovable.app/"
            title="Scenario Vs Goal"
        />
    );
};

export default ScenarioVsGoal;
